import { render, staticRenderFns } from "./BudgetSettings.vue?vue&type=template&id=d01d8e58&scoped=true&"
import script from "./BudgetSettings.vue?vue&type=script&lang=js&"
export * from "./BudgetSettings.vue?vue&type=script&lang=js&"
import style0 from "./BudgetSettings.vue?vue&type=style&index=0&id=d01d8e58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01d8e58",
  null
  
)

export default component.exports